"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_MESSAGE_TYPE = void 0;
exports.POST_MESSAGE_TYPE = 'web-lk-message';
